module.exports = __webpack_public_path__ + "static/media/in-white-logo-only.54eb0414.png";